import { Button, styled, Typography } from '@mui/material';

export const TemplatesContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Template = styled(Button)(({ theme }) => ({
  border: theme.border.default,
  borderRadius: theme.border.radius2,
  padding: theme.spacing(2, 3),
  marginBottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  textAlign: 'left',
  width: '100%',

  '&:hover, &.selected': {
    backgroundColor: theme.palette.primary.background,
    borderColor: theme.palette.primary.main,
    textDecoration: 'none',
  },

  '& img': {
    marginRight: theme.spacing(3),
  },
}));

export const TemplateName = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  lineHeight: theme.typography.body2.lineHeight,
}));
